import { Fragment } from 'react';
import { Link } from 'react-router-dom';

/** One breadcrumb segment: `label` is always shown; add `to` to make it a link (omit on the current page). */
export type BreadcrumbItem = { label: string; to?: string };

type BreadcrumbTrailProps = {
    items: BreadcrumbItem[];
};

const BreadcrumbTrail = ({ items }: BreadcrumbTrailProps) => (
    <p className="text-[11px] 2xl:text-xs text-[var(--secondary-color)]">
        {items.map((item, i) => (
            <Fragment key={`${item.label}-${i}`}>
                {i > 0 && <span className="text-[var(--secondary-color)]"> / </span>}
                {item.to ? (
                    <Link
                        to={item.to}
                        className="text-[var(--secondary-color)] hover:underline hover:text-[var(--primary-color)] transition-colors"
                    >
                        {item.label}
                    </Link>
                ) : (
                    <span className="text-[var(--subtitle-color)]">{item.label}</span>
                )}
            </Fragment>
        ))}
    </p>
);

export default BreadcrumbTrail;
